if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();

        this.dispatchEvent(
          new CustomEvent('zelnuro-modal-hidden')
        );
      }

      show(opener) {
        super.show(opener);

        this.showActiveMedia();

        this.dispatchEvent(
          new CustomEvent('zelnuro-modal-shown')
        );
      }

      showActiveMedia() {
        const mediaId =
          this.openedBy?.getAttribute('data-media-id');

        if (!mediaId) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia =
          this.querySelector(
            `[data-media-id="${mediaId}"]`
          );

        if (!activeMedia) return;

        const activeMediaTemplate =
          activeMedia.querySelector('template');

        const activeMediaContent =
          activeMediaTemplate
            ? activeMediaTemplate.content
            : null;

        activeMedia.classList.add('active');

        requestAnimationFrame(() => {
          activeMedia.scrollIntoView({
            block: 'center',
            inline: 'center'
          });
        });

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}


/* =========================================================
   ZELNURO
   MODAL + SWIPE + ZOOM PROPIO

   SIN ZOOM:
   1 dedo izquierda/derecha = cambiar foto

   CON ZOOM:
   2 dedos = ampliar/reducir
   1 dedo = mover solamente ESA foto
   NO permite cambiar de foto hasta volver a escala 1
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll('product-modal')
    .forEach((modal) => {

      const container =
        modal.querySelector(
          '.product-media-modal__content'
        );

      if (!container) return;


      /* =============================
         PRECARGAR IMÁGENES
         ============================= */

      modal.querySelectorAll('img').forEach((img) => {

        if (img.dataset.src && !img.src) {
          img.src = img.dataset.src;
        }

        if (img.dataset.srcset && !img.srcset) {
          img.srcset = img.dataset.srcset;
        }

        const preload = new Image();

        preload.src =
          img.currentSrc || img.src;

      });


      /* =============================
         ESTADO DEL ZOOM
         ============================= */

      let scale = 1;

      let translateX = 0;
      let translateY = 0;

      let modo = null;

      let inicioX = 0;
      let inicioY = 0;

      let inicioTranslateX = 0;
      let inicioTranslateY = 0;

      let distanciaPinchInicial = 0;
      let escalaPinchInicial = 1;

      let huboPinch = false;


      /*
        MUY IMPORTANTE:

        Desactivamos el zoom/pan nativo
        SOLO dentro del visor del producto.

        Nosotros controlaremos esos gestos.
      */

      container.style.touchAction = 'none';
      container.style.overscrollBehavior = 'contain';


      /* =============================
         MEDIO ACTIVO
         ============================= */

      function obtenerActivo() {

        return container.querySelector(
          '[data-media-id].active'
        );

      }


      function mediosPermitidos() {

        return Array.from(
          container.children
        ).filter((medio) => {

          if (
            !medio.hasAttribute('data-media-id')
          ) {
            return false;
          }

          /*
            Compatible con el filtro
            de colores que ya hicimos.
          */

          if (
            medio.dataset.zelnuroPermitido ===
            'false'
          ) {
            return false;
          }

          if (
            getComputedStyle(medio).display ===
            'none'
          ) {
            return false;
          }

          return true;

        });

      }


      /* =============================
         TRANSFORMACIÓN
         ============================= */

      function limitarTraslacion() {

        const activo =
          obtenerActivo();

        if (!activo || scale <= 1) {

          translateX = 0;
          translateY = 0;

          return;
        }


        /*
          Límites aproximados según
          el tamaño ampliado de la foto.

          Esto evita que salga disparada
          hacia los lados.
        */

        const ancho =
          activo.offsetWidth;

        const alto =
          activo.offsetHeight;


        const maxX =
          Math.max(
            0,
            (ancho * scale - container.clientWidth) / 2
          );


        const maxY =
          Math.max(
            0,
            (alto * scale - container.clientHeight) / 2
          );


        translateX =
          Math.max(
            -maxX,
            Math.min(maxX, translateX)
          );


        translateY =
          Math.max(
            -maxY,
            Math.min(maxY, translateY)
          );

      }


      function aplicarTransformacion(
        animar = false
      ) {

        const activo =
          obtenerActivo();

        if (!activo) return;


        limitarTraslacion();


        activo.style.transformOrigin =
          'center center';

        activo.style.willChange =
          'transform';


        activo.style.transition =
          animar
            ? 'transform 180ms ease'
            : 'none';


        activo.style.transform =
          `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;

      }


      function resetZoom(animar = false) {

        scale = 1;

        translateX = 0;
        translateY = 0;

        const medios =
          container.querySelectorAll(
            '[data-media-id]'
          );


        medios.forEach((medio) => {

          medio.style.transformOrigin =
            'center center';

          medio.style.transition =
            animar
              ? 'transform 180ms ease'
              : 'none';

          medio.style.transform =
            'translate3d(0,0,0) scale(1)';

        });

      }


      /* =============================
         DISTANCIA ENTRE DOS DEDOS
         ============================= */

      function distanciaEntreDedos(touches) {

        if (touches.length < 2) {
          return 0;
        }

        const dx =
          touches[0].clientX -
          touches[1].clientX;

        const dy =
          touches[0].clientY -
          touches[1].clientY;

        return Math.hypot(dx, dy);

      }


      /* =============================
         CAMBIAR DE IMAGEN
         ============================= */

      function cambiarImagen(direccion) {

        /*
          REGLA PRINCIPAL:

          Con zoom jamás se permite
          cambiar de fotografía.
        */

        if (scale > 1.01) {
          return;
        }


        const medios =
          mediosPermitidos();


        if (medios.length < 2) {
          return;
        }


        const actual =
          obtenerActivo();


        let indice =
          medios.indexOf(actual);


        if (indice < 0) {
          indice = 0;
        }


        let nuevoIndice =
          indice + direccion;


        /*
          Sin loop infinito.

          Al llegar a la última,
          se queda ahí.
        */

        if (nuevoIndice < 0) {
          nuevoIndice = 0;
        }

        if (
          nuevoIndice >= medios.length
        ) {
          nuevoIndice =
            medios.length - 1;
        }


        if (nuevoIndice === indice) {
          return;
        }


        resetZoom(false);


        container
          .querySelectorAll(
            '[data-media-id]'
          )
          .forEach((medio) => {

            medio.classList.remove(
              'active'
            );

          });


        const siguiente =
          medios[nuevoIndice];


        siguiente.classList.add(
          'active'
        );


        requestAnimationFrame(() => {

          siguiente.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          });

        });

      }


      /* =================================================
         TOUCH START
         ================================================= */

      container.addEventListener(
        'touchstart',
        (event) => {

          /*
            Evita que Chrome haga zoom
            de toda la página.
          */

          if (event.cancelable) {
            event.preventDefault();
          }


          /* ---------- PINCH ---------- */

          if (event.touches.length >= 2) {

            modo = 'pinch';

            huboPinch = true;


            distanciaPinchInicial =
              distanciaEntreDedos(
                event.touches
              );


            escalaPinchInicial =
              scale;


            return;
          }


          if (event.touches.length !== 1) {
            return;
          }


          const toque =
            event.touches[0];


          /*
            Si ya está ampliada:
            1 dedo = mover imagen.
          */

          if (scale > 1.01) {

            modo = 'pan';

            inicioX =
              toque.clientX;

            inicioY =
              toque.clientY;

            inicioTranslateX =
              translateX;

            inicioTranslateY =
              translateY;

          } else {

            /*
              Escala normal:
              1 dedo = posible swipe.
            */

            modo = 'swipe';

            inicioX =
              toque.clientX;

            inicioY =
              toque.clientY;

          }

        },
        { passive: false }
      );


      /* =================================================
         TOUCH MOVE
         ================================================= */

      container.addEventListener(
        'touchmove',
        (event) => {

          if (event.cancelable) {
            event.preventDefault();
          }


          /* ---------- PINCH ---------- */

          if (
            event.touches.length >= 2
          ) {

            if (modo !== 'pinch') {

              modo = 'pinch';

              huboPinch = true;

              distanciaPinchInicial =
                distanciaEntreDedos(
                  event.touches
                );

              escalaPinchInicial =
                scale;

            }


            const distanciaActual =
              distanciaEntreDedos(
                event.touches
              );


            if (
              distanciaPinchInicial <= 0
            ) {
              return;
            }


            let nuevaEscala =
              escalaPinchInicial *
              (
                distanciaActual /
                distanciaPinchInicial
              );


            /*
              Zoom entre 1x y 4x.
            */

            nuevaEscala =
              Math.max(
                1,
                Math.min(
                  4,
                  nuevaEscala
                )
              );


            scale =
              nuevaEscala;


            /*
              Cuando vuelve prácticamente
              a 1x, centramos de nuevo.
            */

            if (scale <= 1.02) {

              scale = 1;

              translateX = 0;
              translateY = 0;

            }


            aplicarTransformacion(false);

            return;
          }


          /*
            Después de un pinch,
            si queda un dedo sobre pantalla,
            no hacemos nada hasta que
            suelte completamente.

            Esto evita los saltos bruscos.
          */

          if (
            huboPinch &&
            event.touches.length === 1
          ) {
            return;
          }


          /* ---------- PAN ---------- */

          if (
            modo === 'pan' &&
            scale > 1.01 &&
            event.touches.length === 1
          ) {

            const toque =
              event.touches[0];


            translateX =
              inicioTranslateX +
              (
                toque.clientX -
                inicioX
              );


            translateY =
              inicioTranslateY +
              (
                toque.clientY -
                inicioY
              );


            aplicarTransformacion(false);

          }

        },
        { passive: false }
      );


      /* =================================================
         TOUCH END
         ================================================= */

      container.addEventListener(
        'touchend',
        (event) => {

          if (event.cancelable) {
            event.preventDefault();
          }


          /*
            Todavía queda algún dedo:
            no terminamos el gesto.
          */

          if (event.touches.length > 0) {
            return;
          }


          /* ---------- FIN DE PINCH ---------- */

          if (
            modo === 'pinch' ||
            huboPinch
          ) {

            /*
              Si terminó prácticamente
              en tamaño normal, lo dejamos
              exactamente en 1x.
            */

            if (scale <= 1.05) {

              scale = 1;

              translateX = 0;
              translateY = 0;

              aplicarTransformacion(true);

            }


            huboPinch = false;

            modo = null;

            return;
          }


          /* ---------- FIN DE PAN ---------- */

          if (modo === 'pan') {

            aplicarTransformacion(false);

            modo = null;

            return;
          }


          /* ---------- FIN DE SWIPE ---------- */

          if (
            modo === 'swipe' &&
            scale <= 1.01
          ) {

            const toque =
              event.changedTouches[0];


            if (!toque) {

              modo = null;

              return;
            }


            const diferenciaX =
              toque.clientX -
              inicioX;


            const diferenciaY =
              toque.clientY -
              inicioY;


            /*
              Swipe horizontal claro.
            */

            if (
              Math.abs(diferenciaX) >= 50 &&
              Math.abs(diferenciaX) >
                Math.abs(diferenciaY)
            ) {

              if (diferenciaX < 0) {

                cambiarImagen(1);

              } else {

                cambiarImagen(-1);

              }

            }

          }


          modo = null;

        },
        { passive: false }
      );


      container.addEventListener(
        'touchcancel',
        () => {

          modo = null;

          huboPinch = false;

        },
        { passive: false }
      );


      /* =============================
         AL ABRIR/CERRAR
         ============================= */

      modal.addEventListener(
        'zelnuro-modal-shown',
        () => {

          resetZoom(false);

        }
      );


      modal.addEventListener(
        'zelnuro-modal-hidden',
        () => {

          resetZoom(false);

        }
      );

    });

});